import { CountryCode } from 'lib/constants/locales';
import { ApiModel, ApiRelationship, ApiResource } from 'lib/interfaces/api';

export enum Disclaimer {
  None = 'none',
  /**
   * Show disclaimer with a checkbox that blocks progress until checked.
   */
  Checkbox = 'checkbox',
  /**
   * Show disclaimer as aside text.
   */
  Default = 'default',
  /**
   * Show BIPA disclaimer text above button. Required if template contains Selfie or Gov verifications. Should not be
   * removed
   */
  Biometric = 'biometric',
}

export interface TemplateAttributes {
  name?: string;
  'template-id'?: string;
  'intro-disclaimer'?: Disclaimer;
  'enabled-country-codes'?: CountryCode[];
  'enabled-locales': string[];
  'force-link-from-react-native'?: boolean;
  'auto-trigger-complete-event'?: boolean;
  'document-prompt-capture-button'?: string;
  'skip-intro-page'?: boolean;
  'has-support'?: boolean;
  'camera-support-external-link'?: string;
  'steps-config-types-count'?: number;
  'custom-translations'?: CustomTranslation[];
  'hide-verify-back-button'?: boolean;
  'hide-verify-exit-button'?: boolean;
}

export interface CustomTranslation {
  lang: string;
  'translation-url': string;
}

export interface TemplateRelationships {
  'default-theme'?: ApiRelationship;
  organization?: ApiRelationship;
}

export type Template = ApiResource<TemplateAttributes, TemplateRelationships, ApiModel.Template>;
